import React, { useContext } from "react"

type Translations = { [key: string]: string }

const TranslationContext = React.createContext<Translations>({})

const TranslationProvider = TranslationContext.Provider
const TranslationConsumer = TranslationContext.Consumer

/* I wouldn't normally name something a single letter variable, but this
 * matches the I18N.t helper.
 */
const T: React.FC<{ tKey: string }> = ({ tKey }) => (
  <TranslationConsumer>
    {(translations) => translations[tKey]}
  </TranslationConsumer>
)

function useTranslation() {
  return useContext(TranslationContext)
}

export {
  TranslationContext as default,
  TranslationProvider,
  TranslationConsumer,
  Translations,
  useTranslation,
  T
}
